// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SEO_TITLE_REVIEW_PAGE_COMPONENT_REVIEWS = "Recenzie/hodnotenia";
export const SEO_TITLE_REVIEW_PAGE_COMPONENT_WHERE_TO_BUY = "Kde k\u00fapi\u0165";
export const WIKI_WRITE_EXPERIENCE = "Nap\u00ed\u0161 sk\u00fasenos\u0165";
